import React from 'react';

import confirmDate from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {SweetDatePicker} from 'app/general/widgets/SweetDatePicker';
import {gt} from 'app/utils/i18n';

import {StepTaskFieldProps} from '../commonprops';
import {FieldLastEditStamp} from '../FieldLastEditStamp';
import {TaskFieldSubmitButton} from '../TaskFieldSubmitButton';

export const StepTaskDateField = ({
  field,
  onSubmit,
  inputValueChanged,
  isSaving,
  progress,
  value,
  initial,
  blocked,
}: StepTaskFieldProps) => (
  <div className="form-group row mb-0">
    {field.label !== '' ? (
      <label
        htmlFor={`step-field-${field.id}`}
        className="col-12 col-form-label pt-0"
      >
        {field.label}
      </label>
    ) : null}
    <div className="col-12">
      <SweetDatePicker
        data-enable-time
        options={{
          plugins: [
            confirmDate({
              confirmIcon: '',
              showAlways: true,
            }),
          ],
        }}
        value={[value]}
        format={'lll'}
        className="input-group"
        onChange={(dates) => inputValueChanged(dates[0])}
      >
        <input
          disabled={blocked}
          id={`step-field-${field.id}`}
          className="form-control"
          type="text"
          data-input={true}
        />
        {value !== '' ? (
          <LazyTooltip tooltip={gt('Clear time value')}>
            <div className="input-group-append">
              <button
                className="btn btn-light"
                onClick={() => inputValueChanged(null)}
              >
                <i className="far fa-times" />
              </button>
            </div>
          </LazyTooltip>
        ) : null}
        <div className="input-group-append">
          <LazyTooltip tooltip={gt('Set time to now')}>
            <button
              className="btn btn-light"
              onClick={() => inputValueChanged(new Date())}
            >
              <i className="fal fa-clock" />
            </button>
          </LazyTooltip>
        </div>
        <TaskFieldSubmitButton
          progress={progress}
          isSaving={isSaving}
          value={value}
          initial={initial}
          blocked={blocked}
          onSubmit={onSubmit}
        />
      </SweetDatePicker>
      <FieldLastEditStamp progress={progress} />
    </div>
  </div>
);
